import { useState } from "react";
import QuotationCreate from "./quotation/QuotationCreate";
import QuotationList from "./quotation/QuotationList";

export default function HRMSSystemSettings() {
  const [activeTab, setActiveTab] = useState("Create Quotation");

  const tabs = ["Create Quotation", "Manage Quotations"];

  return (
    <div className="flex min-h-full flex-col bg-slate-50">
      {/* Main Content */}
      <main className="flex-1 flex flex-col">
        {/* Content Area */}
        <div className="flex-1 px-4 py-6 sm:px-8">
          {/* Page Title */}
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-slate-800 mb-2">
              Quotation Management
            </h2>
            <p className="text-slate-600">
              Manage quotations and billing information
            </p>
          </div>

          {/* Tabs */}
          <div className="mb-8 border-b border-slate-200">
            <div className="flex gap-1 overflow-x-auto">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-6 py-3 text-sm font-medium whitespace-nowrap transition-all relative ${
                    activeTab === tab
                      ? "text-indigo-600"
                      : "text-slate-600 hover:text-slate-800"
                  }`}
                >
                  {tab}
                  {activeTab === tab && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-indigo-600"></div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {activeTab === "Create Quotation" ? (
            <QuotationCreate />
          ) : (
            <QuotationList />
          )}

          {/* Info Card */}
          <div className="mt-6 p-4 bg-indigo-50 border border-indigo-200 rounded-xl">
            <div className="flex gap-3">
              <div className="flex-shrink-0">
                <svg
                  className="w-5 h-5 text-indigo-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <p className="text-sm text-indigo-900">
                  <span className="font-semibold">Note:</span> Ensure all
                  quotation details are accurate before sending to clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
